import React from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    userInfoSelectors,
    createAccountAction,
    logInAction,
} from 'wanderu-ducks-account';
import {
    selectLocale,
    localize,
} from 'wanderu-i18n';

import SignUp from '../../components/SignUp/SignUp';
import baseAppConfig from '../../config/baseApp.locales';

function BareSignUpContainer(props) {
    const {
        locale,
        createAccountAndLogIn,
        error,
        loading,
        facebookLogIn,
        googleButtonLogIn,
        resetCreateAccountAction,
        success,
        referralCode,
        ...otherProps
    } = props;

    function _createAccountAndLogIn(accountInfo) {
        createAccountAndLogIn({
            ...accountInfo,
            referralCode,
            locale,
        });
    }

    return (
        <SignUp
            error={error}
            loading={loading}
            onCreateAccount={_createAccountAndLogIn}
            onFacebookClick={facebookLogIn}
            onGoogleClick={googleButtonLogIn}
            reset={resetCreateAccountAction}
            success={success}
            {...otherProps}
        />
    );
}

BareSignUpContainer.propTypes = {
    cognitoLogIn: PropTypes.func,
    locale: PropTypes.string,
    facebookLogIn: PropTypes.func,
    googleButtonLogIn: PropTypes.func,
    createAccountAndLogIn: PropTypes.func,
};

BareSignUpContainer.defaultProps = {
    createAccountAndLogIn() {},
    facebookLogIn() {},
    googleButtonLogIn() {},
    resetCreateAccountAction() {},
};

const mapStateToProps = (appState) => {
    return {
        locale: selectLocale(appState),
        loading: createAccountAction.selectWorking(appState),
        error: createAccountAction.selectError(appState),
        success: createAccountAction.selectSuccess(appState),
    };
};

const mapDispatchToProps = {
    facebookLogIn: logInAction.facebookLogIn,
    googleButtonLogIn: logInAction.googleButtonLogIn,
    createAccountAndLogIn: createAccountAction.createAccountAndLogIn,
    resetCreateAccountAction: createAccountAction.reset,
};

export {
    BareSignUpContainer,
    mapStateToProps,
};

// const localizedSignUpContainer = localize(SignUpContainer, [`t`], baseAppConfig.namespace);
export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(BareSignUpContainer);
